import React, { useEffect, useState } from 'react';
import { useGetContactsNewsQuery } from '../../api/contact.js';
import ThreeDotsLoader from '../misc/ThreeDotsLoader.jsx';
import BaseCard from '../misc/BaseCard.jsx';
import { Dialog } from 'primereact/dialog';
import dayjs from 'dayjs';
import IconExternalLink from '../images/IconExternalLink.jsx';

const ContactNews = ({ contactId, newsEnabled }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [allNews, setAllNews] = useState([]);
    const [selectedNews, setSelectedNews] = useState(null);
    const newsPerPage = 3;

    const {
        data: newsData,
        isLoading: newsLoading,
        isFetching: newsFetching
    } = useGetContactsNewsQuery({ page: currentPage, per_page: newsPerPage, id: contactId });

    const hasMorePages = newsData?.response?.has_more_pages || false;

    const mergeNews = (newNews) => {
        setAllNews((prevNews) => {
            const existingIds = new Set(prevNews.map((news) => news.id));
            const filteredNewNews = newNews.filter((news) => !existingIds.has(news.id));
            return [...prevNews, ...filteredNewNews];
        });
    };

    useEffect(() => {
        if (newsData?.response?.news) {
            mergeNews(newsData.response.news);
        }
    }, [newsData]);

    const handleLoadMore = () => {
        if (hasMorePages) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };

    return (
        <div className='max-w-3xl w-full mx-auto px-8 pb-2'>
            {!newsEnabled && allNews.length !== 0 ? (
                <div className='text-lg text-theme1-title2 font-bold mb-4'>News</div>
            ) : null}

            {newsLoading && currentPage === 1 ? (
                <ThreeDotsLoader />
            ) : (
                <>
                    {allNews.map((news) => (
                        <BaseCard className='p-6 mb-6 mt-0' key={news.id}>
                            <div className='text-sm text-theme1-text3 mb-1 font-bold'>{news.source}</div>
                            <a
                                href={news.url}
                                target='_blank'
                                rel='noreferrer'
                                className='text-theme1-primary font-bold text-lg'
                            >
                                {news.title}{' '}
                                <IconExternalLink className='w-3 h-3 inline-block fill-theme1-primary ml-1' />
                            </a>
                            <div className='text-xs text-theme1-text4 mt-1'>
                                {dayjs(news.published_at).format('DD.MM.YYYY')}
                            </div>

                            <p className='text-sm text-theme1-text1 mt-3'>
                                {news.content.slice(0, 100)}...
                                <button
                                    className='text-theme1-primary font-bold text-sm'
                                    onClick={() => setSelectedNews(news)}
                                >
                                    View More
                                </button>
                            </p>
                        </BaseCard>
                    ))}
                </>
            )}

            {hasMorePages && (
                <div className='text-center'>
                    <button
                        onClick={handleLoadMore}
                        disabled={newsFetching}
                        className='bg-none border-none text-theme1-title2 font-bold p-0 text-lg disabled:opacity-50'
                    >
                        {newsFetching ? 'Loading...' : 'Load more news'}
                    </button>
                </div>
            )}

            <Dialog
                visible={!!selectedNews}
                onHide={() => setSelectedNews(null)}
                header={selectedNews?.title}
                style={{ width: '95vw' }}
                maximizable
                blockScroll={true}
            >
                <p className='text-theme1-text1 whitespace-pre-wrap'>{selectedNews?.content}</p>
            </Dialog>
        </div>
    );
};

export default ContactNews;
